<template>
  <button
    class="btn"
    :disabled="disabled"
    v-bind="$attrs"
    :style="{
      background: disabled ? 'rgba(0, 0, 0, 0.16)': background,
      color: disabled ? 'rgba(0, 0, 0, 0.16)' : colorTexto,
      borderRadius: `${radius}px`,
      maxWidth: width ? width : ''
    }"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "SysBotao",
  props: {
    width: {
      type: [Number, String]
    },
    background: {
      type: String,
      default: '#f1f2fd'
    },
    colorTexto: {
      type: String,
      default: '#142454'
    },
    radius: {
      type: [Number, String],
      default: 10
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.btn {
  padding: 6px 18px;
}
</style>
